import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: React.ReactNode;
  description?: string;
  actions?: React.ReactNode;
  noPadding?: boolean;
  noHoverShadow?: boolean;
}
export function Card({
  children,
  className = '',
  title,
  description,
  actions,
  noPadding = false,
  noHoverShadow = false
}: CardProps) {
  return <div className={`bg-white rounded-2xl border border-slate-100 shadow-sm ${noHoverShadow ? '' : 'hover:shadow-md'} transition-shadow duration-300 ${className}`} data-id="element-1906" data-mp="d4rfnjsydosm">
      {(title || actions) && <div className="px-6 py-5 border-b border-slate-50 flex justify-between items-start sm:items-center gap-4" data-id="element-1907" data-mp="r2g4f2q55g2y">
          <div data-id="element-1908" data-mp="w19a48z6s2sk">
            {title && <h3 className="text-lg font-bold text-slate-900 tracking-tight" data-id="element-1909" data-mp="w10u487rohd5">
                {title}
              </h3>}
            {description && <p className="mt-1 text-sm text-slate-500" data-id="element-1910" data-mp="2xs454ylkjxy8">{description}</p>}
          </div>
          {actions && <div className="flex items-center gap-2" data-id="element-1911" data-mp="2zi4risfgt4ke">{actions}</div>}
        </div>}
      <div className={noPadding ? '' : 'p-6'} data-id="element-1912" data-mp="2uq37ulfywbkc">{children}</div>
    </div>;
}